import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  MenuItem,
  styled,
  TextField,
  Typography,
} from '@mui/material';
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { QueryCache, useMutation, useQuery, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useFind, useMany, useSaver } from '../../hooks/api';
import { DefaultEmp, IEmp } from '../../models/emp';
import { SwSnackbar } from '../commonComponent/views/SwSnackbar';
import { SwAlert } from '../commonComponent/views/SwAlert';
import {
  getAccountRoleList,
  postAccountRegister,
} from '../../common/api/ApiAccount';
import {
  KEY_ACCOUNT_LIST,
  KEY_ACCOUNT_ROLE_LIST,
  KEY_ACCOUNT_REGISTER,
  KEY_SCHOOL_LIST,
} from '../../common/key';
import { RESULT_OK } from '../../common/resultCode';
import { useSession } from '../../hooks/session';
import {
  educationOffices,
  getSchoolClassCount,
  getSchoolGradeCount,
  getSchoolInSchoolGroup,
  schoolGroups,
} from '../../common/helper';

interface Props {
  role: any;
  open: boolean;
  onclose: () => void;
  isEdit: boolean;
  account: any;
  title: string;
}

const JoinTextField = styled(TextField)({
  width: '29.4rem',
});

const JoinDivider = styled(Divider)({
  margin: '.7rem 0',
});

export const JoinDialog: React.FC<Props> = ({
  role,
  open,
  onclose,
  isEdit,
  account,
  title,
}) => {
  const { loginVal } = useSession();

  const queryClient = useQueryClient();
  const [check, setCheck] = useState<boolean>(false);
  const [checkContents, setCheckContents] = useState<string>('');
  const onCloseCheck = () => setCheck(!check);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<any>();
  const onChangeAlertOpen = () => setAlertOpen(!alertOpen);
  const [name, setName] = useState<any>('');
  const [phoneNumber, setPhoneNumber] = useState<any>('');
  const [id, setId] = useState<any>('');
  const [password, setPassword] = useState<any>('');
  const [selectRole, seSelectRole] = useState<any>(1);
  const [view, setView] = useState<boolean>(false);

  const [schoolList, setSchoolList] = useState<any[]>([]);
  const [schools, setSchools] = useState<any[]>([]);
  const [educationOfficeSeq, setEducationOfficeSeq] = useState<number>(0);
  const [schoolSeq, setSchoolSeq] = useState<number>(0);
  const [schoolClassSeq, setSchoolClassSeq] = useState<number>(0);
  const [schoolGroupSeq, setSchoolGroupSeq] = useState<number>(1);
  const [schoolGrade, setSchoolGrade] = useState<number>(1);
  const [schoolClass, setSchoolClass] = useState<string>('1');
  const [customSchoolClass, setCustomSchoolClass] = useState<string>('');
  const [schoolName, setSchoolName] = useState<string>('');
  const [alertTitle, setDialogTitle] = useState<string>('');
  const [dialogMessage, setDialogMessage] = useState<string>('');
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [openSnackbar, setOpenSnackbar] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<number>(0);

  const roleList = [
    { name: '일반(선생님)', role: 1 },
    { name: '관리자1(교장)', role: 2 },
    { name: '관리자2(교육청)', role: 3 },
  ];

  const reloadSchools = (
    newSchoolList: any[],
    newSchoolGroupSeq: number,
    newEducationOfficeSeq: number
  ) => {
    const newSchools = getSchoolInSchoolGroup(
      newSchoolList,
      newSchoolGroupSeq,
      newEducationOfficeSeq
    );
    setSchools(newSchools);
  };

  const inputSet = [
    {
      title: '아이디',
      value: id,
      setValue: setId,
      placeholder: '영문 아이디를 입력해 주세요.',
    },
    {
      title: '비밀번호',
      value: password,
      setValue: setPassword,
      placeholder: '비밀번호를 입력해 주세요.',
    },
  ];

  const { mutate, isError: isMutateError } = useMutation(postAccountRegister, {
    onSuccess: res => {
      if (res.resultCode === RESULT_OK) {
        queryClient.invalidateQueries(KEY_ACCOUNT_LIST);
        setCheckContents('계정이 생성되었습니다.');
        setCheck(true);
        onclose();
      } else {
        setCheckContents(
          `계정을 추가하는 동안 오류가 발생했습니다.(${res.resultCodeMsg})`
        );
      }
      setCheck(true);
    },
    onError: error => {
      setCheckContents(
        '계정생성 과정에서 오류가 발생했습니다. 다시 시도해 주시기 바랍니다.'
      );
      setCheck(true);
      console.log(error);
    },
  });

  const Signup = () => {
    var val = 0;

    if (id.length === 0) {
      setCheckContents('아이디를 입력해주세요.');
      setCheck(true);
      val = 3;
    } else if (password.length === 0) {
      setCheckContents('비밀번호를 입력해주세요.');
      setCheck(true);
      val = 4;
    } else if ((selectRole === 1 || selectRole === 2) && schoolSeq === 0) {
      setCheckContents('학교를 선택해주세요.');
      setCheck(true);
      val = 5;
    }

    if (val === 0) {
      // const newRole = role
      //   ?.map((item: any, idx: number) => {
      //     if (item === selectRole) return idx;
      //     return -1;
      //   })
      //   .filter((item: any) => item !== -1);
      const newEmp = {
        schoolClassSeq: schoolClassSeq,
        educationOfficeSeq: educationOfficeSeq,
        schoolSeq: schoolSeq,
        schoolName: schoolName,
        schoolGroupSeq: schoolGroupSeq,
        schoolGrade: schoolGrade,
        schoolClass: schoolClass !== '0' ? schoolClass : customSchoolClass,
        id: id,
        password: password,
        role: selectRole,
      };
      mutate(newEmp);
    }
  };

  useEffect(() => {
    reloadSchools(schoolList, schoolGroupSeq, educationOfficeSeq);
  }, [schoolGroupSeq, educationOfficeSeq]);

  useEffect(() => {
    setEducationOfficeSeq(account?.educationOfficeSeq ?? 1);
    setSchoolSeq(account?.schoolSeq ?? 0);
    setSchoolGroupSeq(account?.schoolGroupSeq ?? 0);
    setSchoolClass(account?.schoolClass ?? 0);
    setSchoolGrade(account?.schoolGrade ?? 0);
    setSchoolName(account?.schoolName ?? '');

    setId(account?.id ?? '');
    setPassword(account?.passwordExt ?? '');
    seSelectRole(account?.role ?? 1);
  }, [schoolList]);

  useEffect(() => {
    if (open) {
      const savedSchoolList = localStorage.getItem(KEY_SCHOOL_LIST);
      if (savedSchoolList) {
        const newSchoolList = JSON.parse(savedSchoolList);
        setSchoolList(newSchoolList);
      }
    } else {
      setSchoolSeq(0);
      setSchoolClassSeq(0);
      setEducationOfficeSeq(1);
      setSchoolGroupSeq(1);
      setSchoolName('');
      setSchoolGrade(1);
      setSchoolClass('1');

      setId('');
      setPassword('');
      seSelectRole(1);
      setView(false);
    }
  }, [open]);

  return (
    <>
      <Dialog
        open={open}
        onClose={onclose}
        sx={{
          '& .MuiDialog-paper': {
            width: '31rem',
          },
        }}
      >
        <DialogTitle>
          <Box className='flex_between'>
            {title}
            <IconButton onClick={onclose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider sx={{ m: 0, p: 0 }} />
        <DialogContent sx={{ ml: '.2rem' }}>
          <Box>
            <Typography className='title'>권한</Typography>
            <JoinTextField
              disabled={isEdit}
              placeholder='일반'
              select
              value={selectRole}
              onChange={(
                evt: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
              ) => seSelectRole(evt.target.value)}
            >
              {roleList.map((item: any, idx: number) => (
                <MenuItem value={item.role} key={idx.toString()}>
                  {item.name}
                </MenuItem>
              ))}
            </JoinTextField>
          </Box>
          <Box>
            <Typography className='title'>교육지원청</Typography>
            <Box className='flex_start'>
              <TextField
                disabled={isEdit}
                sx={{ width: '15rem' }}
                select
                value={educationOfficeSeq}
                onChange={evt =>
                  setEducationOfficeSeq(Number(evt.target.value))
                }
              >
                <MenuItem key={`educatin_office_${0}`} value={0}>
                  선택
                </MenuItem>
                {educationOffices.map((item: any, idx: number) => (
                  <MenuItem key={`educatin_office_${idx}`} value={item.seq}>
                    {item.name}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Box>
          {/* <Divider sx={{ m: 0, p: 0 }} /> */}
          {(selectRole === 1 || selectRole === 2) && (
            <Box>
              <Typography className='title'>학교</Typography>
              <Box className='flex_start'>
                <TextField
                  disabled={isEdit}
                  sx={{ width: '15rem' }}
                  select
                  value={schoolGroupSeq}
                  onChange={evt => {
                    setSchoolGroupSeq(Number(evt.target.value));
                    setSchoolSeq(0);
                  }}
                >
                  <MenuItem key={`school_group_${0}`} value={0}>
                    초/중/고 선택
                  </MenuItem>
                  {schoolGroups.map((item: any, idx: number) => (
                    <MenuItem key={`school_group_${idx}`} value={item.seq}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  disabled={isEdit}
                  sx={{ width: '15rem', ml: '.5rem' }}
                  select
                  value={schoolSeq}
                  onChange={evt => setSchoolSeq(Number(evt.target.value))}
                >
                  <MenuItem key={`school_${0}`} value={0}>
                    학교 선택
                  </MenuItem>
                  {schools &&
                    schools.map((item: any, idx: number) => (
                      <MenuItem key={`school_${idx}`} value={item.schoolSeq}>
                        {item.schoolName}
                      </MenuItem>
                    ))}
                </TextField>
              </Box>
            </Box>
          )}
          {/* <Divider sx={{ m: 0, p: 0 }} /> */}
          {selectRole === 1 && (
            <>
              <Box>
                <Typography className='title'>학년/반</Typography>
                <Box className='flex_start'>
                  <TextField
                    disabled={isEdit}
                    sx={{ width: '15rem', mr: '.5rem' }}
                    select
                    value={schoolGrade}
                    onChange={evt => setSchoolGrade(Number(evt.target.value))}
                  >
                    {Array.from(
                      { length: getSchoolGradeCount(schoolGroupSeq) },
                      (_, index) => (
                        <MenuItem
                          key={`school_grade_${index + 1}`}
                          value={index + 1}
                        >
                          {`${index + 1} 학년`}
                        </MenuItem>
                      )
                    )}
                  </TextField>
                  <TextField
                    disabled={isEdit}
                    sx={{ width: '10rem' }}
                    select
                    value={schoolClass}
                    onChange={evt => setSchoolClass(evt.target.value)}
                  >
                    <MenuItem key='school_class_0' value='0'>
                      직접 입력
                    </MenuItem>
                    {Array.from(
                      { length: getSchoolClassCount() },
                      (_, index) => (
                        <MenuItem
                          key={`school_class_${index + 1}`}
                          value={index + 1}
                        >
                          {`${index + 1} 반`}
                        </MenuItem>
                      )
                    )}
                  </TextField>
                </Box>
                {schoolClass === '0' && (
                  <TextField
                    placeholder='반 이름 입력'
                    sx={{ width: '15rem' }}
                    value={customSchoolClass}
                    onChange={evt => setCustomSchoolClass(evt.target.value)}
                  />
                )}
              </Box>
              {/* <Divider sx={{ m: 0, p: 0 }} /> */}
            </>
          )}
          {inputSet.map((input, idx) =>
            idx === 0 ? (
              <Box key={idx.toString()}>
                <Typography className='title'>{input.title}</Typography>
                <JoinTextField
                  disabled={input.title === '아이디' && isEdit}
                  placeholder={input.placeholder}
                  value={input.value}
                  InputProps={{
                    endAdornment: input.title === '이름' && (
                      <InputAdornment position='end'>
                        <span>0 / 5</span>
                      </InputAdornment>
                    ),
                  }}
                  onChange={(
                    evt: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
                  ) => input.setValue(evt.target.value)}
                />
              </Box>
            ) : (
              <Box key={idx.toString()}>
                <Typography className='title'>{input.title}</Typography>
                <JoinTextField
                  placeholder={input.placeholder}
                  type={view ? 'text' : 'password'}
                  autoComplete='off'
                  value={input.value}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton onClick={() => setView(!view)}>
                          {view ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onChange={(
                    evt: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
                  ) => input.setValue(evt.target.value)}
                />
              </Box>
            )
          )}
        </DialogContent>
        <Divider sx={{ p: 0, m: 0 }} />
        <DialogActions>
          <Button
            variant='contained'
            color='secondary'
            sx={{ fontSize: '.9rem', mr: '.8rem' }}
            onClick={Signup}
          >
            {isEdit ? '저장' : '완료'}
          </Button>
        </DialogActions>
      </Dialog>
      <SwSnackbar
        open={check}
        onClose={onCloseCheck}
        contents={checkContents}
      />
      <SwAlert
        title={
          alertMessage !== '계정 생성은 워크온 담당자에게 문의해 주세요.'
            ? '로그인 오류'
            : '워크온 담당자'
        }
        open={alertOpen}
        onConfirm={onChangeAlertOpen}
        contents={alertMessage}
      />
    </>
  );
};
